import { BrowserRouter, HashRouter } from "react-router-dom";
import "./App.scss";
import Routing from "routing";
import { Toaster } from "react-hot-toast";
import { AxiosInterceptor } from "config/axiosInstance";
import store from "redux-toolkit/store";
import { Provider } from "react-redux";
import InternetConnection from "components/internet-connection";

function App() {
  return (
    <div className="App">

      {/* <HashRouter> */}
      <BrowserRouter basename='/'>
        <Provider store={store}>
          <AxiosInterceptor>
            <InternetConnection>
              <Routing />
              <Toaster position="top-right" reverseOrder={false} />
            </InternetConnection>
          </AxiosInterceptor>
        </Provider>
      </BrowserRouter>
      {/* </HashRouter> */}
    </div>
  );
}

export default App;
